<template>
    <b-modal
        title-tag="h2"
        :title="title"
        :lazy="true"
        :visible="isOpen"
        @ok="proceed"
    >
        <p>{{ message }}</p>

        <p v-if="isProceed && client && client.isRecordSharing">
            Are you sure you want to delete this client?
            <b-form-group label-cols="0" label-for="isDeleteAll">
                <select
                    id="isDeleteAll"
                    name="isDeleteAll"
                    v-model="isDeleteAll"
                    class="form-control"
                >
                    <option :value="false">Delete from this clinic only</option>
                    <option :value="true"
                        >Delete from all shared clinics</option
                    >
                </select>
            </b-form-group>
        </p>

        <p v-if="isProceed">
            To proceed, type <code class="px-2">{{ confirmationText }}</code> in
            the field below
            <input-confirmation
                class="mt-1"
                ref="inputConfirmation"
                :confirmation-text="confirmationText"
                @is-matched="isMatched => (isConfirmationTextMatch = isMatched)"
            />
        </p>
        <template v-slot:modal-footer>
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isLoading && isProceed"
                variant="primary"
                @click="proceed"
                :disabled="!enableDeleteButton"
            >
                Delete
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Client from "@/services/client";
import Loader from "@/components/elements/loader";
import { find } from "lodash";
import InputConfirmation from "@/module/commons/input-confirmation";

export default {
    components: {
        Loader,
        InputConfirmation
    },
    data() {
        return {
            isOpen: false,
            isLoading: false,
            isProceed: true,
            message: "",
            title: "Delete Client",
            client: null,
            isConfirmationTextMatch: false,
            isDeleteAll: false
        };
    },
    computed: {
        enableDeleteButton() {
            return this.isConfirmationTextMatch;
        },
        confirmationText() {
            return "delete";
        }
    },
    methods: {
        open(client) {
            this.$nextTick(() => {
                if (client) {
                    this.client = client;
                    this.setMessage(0);
                    this.getInfos();
                }
            });
        },
        close() {
            this.isOpen = false;
        },
        async getInfos() {
            let wellnessPlan = await Client.getWellnessPlanByClient(
                this.client.id
            );

            if (
                wellnessPlan.resource.length > 0 &&
                find(wellnessPlan.resource, ["status", 0])
            ) {
                this.setMessage("WELLNESS_PLAN");
                this.isProceed = false;
            } else if (this.client.account_balance != 0) {
                this.setMessage("ACCOUNT_BALANCE");
                this.isProceed = false;
            }
            this.isOpen = true;
        },
        setMessage(type) {
            switch (type) {
                case "WELLNESS_PLAN":
                    this.title = "Unable to Delete Client";
                    this.message =
                        "This client is responsible for one or more active wellness plans, and therefore cannot be deleted.  Please remove the active wellness plan(s) before deleting the client.";
                    break;
                case "ACCOUNT_BALANCE":
                    this.title = "Unable to Delete Client";
                    this.message =
                        "This client has an outstanding balance. Please clear off the balance before proceed deleting this client.";
                    break;
                default:
                    this.message =
                        "Deleting this client will permanently delete any future appointments and reminders, and terminate any existing wellness plans. If this client is a primary owner, his/her’s patient(s) will be assigned to a new primary owner if available. Do you want to delete this client?";
                    break;
            }
        },
        async proceed() {
            try {
                this.isLoading = true;
                let params = {};

                if (this.client.isRecordSharing) {
                    params.is_delete_all = this.isDeleteAll;
                }

                const res = await Client.deleteClient(this.client.id, params);

                if (res.state !== 0) {
                    throw new Error(res.message);
                }

                setTimeout(() => {
                    this._message("Record deleted successfully");
                    this.close();
                    this.$emit("success");
                }, 600);
            } catch (error) {
                this.isLoading = false;
                this._message("Error: Unable to delete", "danger");
            }
        }
    }
};
</script>
